<template>
    <div class="p-1">
        <!-- Заголовок, отображаемый при выборе пункта -->
        <span
            class="custom-label text-xs mt-1 opacity-0 pl-3"
            :class="{ 'opacity-100': model }"
        >
            {{ placeholder }}
        </span>
        <!-- Поле селект -->
        <multiselect
            class="custom-multiselect "
            v-model="model"
            :loading="loading"
            @select="selected"
            @remove="removed"
            @open="getOptions"
            open-direction="top"
            :custom-label="labelForRender"
            track-by="uid"
            :options="options"
            :disabled="disabled"
            deselectLabel=""
            selectLabel=""
            :selectedLabel="$t('selected')"
            @search-change="asyncFind"
            :placeholder="placeholder"
        >
            <div slot="noOptions">{{ $t("no_data") }}</div>
            <div slot="noResult">{{ $t("not_search_result") }}</div>
        </multiselect>
    </div>
</template>

<script>
import debounce from "lodash.debounce";
export default {
    name: "MultiselectCustom",
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        prevEndpoint: {
            type: String,
            required: false,
        },
        prevCount: {
            type: Number,
        },

        placeholder: {
            type: String,
            required: true,
        },
        value: {
        },
        name: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        searchKey: {
            type: String,
            default: null,
        },
        searchObjectEndpoint: {
            type: String,
            default: null,
        },
        param: {
            type: Object,
        },
    },
    data() {
        return {
            loading: false,
            options: [],
            modelIfSearch: null,
        };
    },
    computed: {
        model: {
            get() {
                return JSON.parse(JSON.stringify(this.value))
            },
            set(value) {
                this.$emit("input", value ? value.uid : null);
            },
        },
    },
    methods: {
        async getPrevData() {
            try {
                this.loading = true;

                this.options = (
                    await this.$http.get(this.prevEndpoint)
                ).data.results;
            } catch (e) {
            } finally {
                this.loading = false;
            }
        },
        async getOptions() {
            try {
                this.loading = true;
                if (!this.searchKey) {
                    this.options = (
                        await this.$http.get(this.endpoint, {
                            params: this.param,
                        })
                    ).data;
                } else {
                    if (this.value) {
                        this.options = [
                            (
                                await this.$http.get(
                                    `${ this.searchObjectEndpoint }${ this.value }/`
                                )
                            ).data,
                        ];
                    }
                }
            } catch (e) {
            } finally {
                this.loading = false;
            }
        },
        asyncFind: debounce(async function (value) {
            if (this.searchKey) {
                try {
                    this.loading = true;

                    if (value) {
                        this.options = (
                            await this.$http.get(this.endpoint, {
                                params: {
                                    [this.searchKey]: value,
                                },
                            })
                        ).data;
                    }
                } catch (e) {
                } finally {
                    this.loading = false;
                }
            }
        }, 500),
        labelForRender(data) {
            switch (this.name) {
                case "gender":
                    return `${ data.name }`;
                default:
                    return data["name"];
            }
        },
        selected(value) {
            setTimeout(() => {
                this.$emit("selected", value);
            }, 500);

        },
        removed(value) {
            this.$emit("removed", value);
        },
    },
    watch: {
        "$route.params.lang"() {
            this.getOptions();
        },
    },
    created() {
        if (this.prevEndpoint) this.getPrevData();
        // Если уже имеется выбор, то запроси словарь, чтобы показать его name
        if (this.value) this.getOptions();
    },
};
</script>

<style scoped lang="scss">
.custom-label {
    font-family: unset;
    color: rgba(0, 0, 0, 0.4);
    display: block;
    margin-bottom: 4px;
}
.custom-multiselect::v-deep {
    // z-index: 9999;
    margin-top: 8px;

    .multiselect__placeholder {
        color: rgba(0, 0, 0, 0.4);
    }

    .multiselect__tags {
        //height: 38px;
        //min-height: auto !important;
    }
}
</style>
